export const ru = {
  'chat-screen-title': 'Чат трансляции',
  'no-data': 'Нет данных',
}
